import { AbstractAuthenticationAppRouterService } from "@shopliftr/common-ng";
import { Injectable } from "@angular/core";
import { PartnerRoutingId } from "../enums/partner-routing-id";

/**
 * The RouterService for the Partner application.
 *
 * A RouterService should be created for each application.
 * It is the way that Components, Directives and Services will interact with the router.
 *
 * @see AbstractAuthenticationAppRouterService
 * @see PartnerRoutingId
 */
@Injectable()
export class AppRouterService extends AbstractAuthenticationAppRouterService<PartnerRoutingId> {

    get isWelcome(): boolean {
        return this.isRouteActive(PartnerRoutingId.Welcome);
    }

    get isApiCredentials(): boolean {
        return this.isRouteActive(PartnerRoutingId.ApiCredentials);
    }

    get isDealsApi(): boolean {
        return this.isRouteActive(PartnerRoutingId.DealsApi);
    }

    get isInspire(): boolean {
        return this.isRouteActive(PartnerRoutingId.Inspire);
    }

    toWelcome(): void {
        this._navigateByRouteId(PartnerRoutingId.Welcome);
    }

    toApiCredentials(): void {
        this._navigateByRouteId(PartnerRoutingId.ApiCredentials);
    }

    toDealsApi(): void {
        this._navigateByRouteId(PartnerRoutingId.DealsApi);
    }

    toInspire(): void {
        this._navigateByRouteId(PartnerRoutingId.Inspire);
    }
}
